var enDeTranslation = {
    "contact_us.buttonText": "Help",
    "contact_us.error.email": "Please enter a valid email",
    "contact_us.error.general": "Oops... Something went wrong. Please try again.",
    "contact_us.error.minimum_two_chars": "Should be at least 2 chars long",
    "contact_us.placeholders.email": "Email Address",
    "contact_us.placeholders.name": "Full Name",
    "contact_us.placeholders.text": "How can we help?",
    "contact_us.send": "Send",
    "contact_us.subtitle": "Fill in your details, write your question, and we will get back to you",
    "contact_us.success.ok": "Ok",
    "contact_us.success.subtitle": "We got your message and will get back to you as soon as possible.",
    "contact_us.success.title": "Thanks {{name}}!",
    "contact_us.title": "Ask Us Anything",
    "language.select.label": "Select your language",
    "cookie_consent.customize.categories.essential.description": "",
    "cookie_consent.customize.categories.essential.title": "",
    "cookie_consent.customize.categories.performance.description": "These help us measure performance and analyse visits to our site so we can keep improving our experience",
    "cookie_consent.customize.categories.performance.title": "Performance cookies",
    "cookie_consent.customize.confirm_btn_title": "",
    "cookie_consent.customize.title": "",
    "cookie_consent.information.accept_btn_title": "",
    "cookie_consent.information.cookies_policy_link_text": "",
    "cookie_consent.information.customize_btn_title": "",
    "cookie_consent.information.description": "",
    "cookie_consent.information.title": "",
    "cxai.browser_toast": "For an optimal chat experience we recommend\nChrome, Safari, or Edge browsers",
    "cxai.default_description": "Personal Insurance Assistant",
    "cxai.error.message": "Something went wrong...",
    "cxai.error.retry": "RETRY",
    "cxai.phone_input.mobile_title": "",
    "cxai.phone_input.no_results": "",
    "cxai.phone_input.placeholder": "",
    "cxai.restart.action": "",
    "cxai.restart.close": "",
    "cxai.restart.content": "",
    "cxai.restart.title": "",
    "error_page.action": "Take me home",
    "error_page.subtitle": "Couldn't find the page you were looking for.",
    "error_page.title": "Oops.",
    "footer.disclaimer": "*For contents policies in postal code 10437 with 10,000 € coverage (loss of use not included).\nFor contents & liability policies this includes an added liability coverage of 2 € /mo.",
    "footer.titles.company": "company",
    "footer.titles.features": "features",
    "footer.titles.privateLiabilityInsurance": "Private Liability Insurance",
    "footer.titles.get_app": "get our app",
    "footer.titles.products": "",
    "footer.titles.resources": "resources",
    "footer.titles.social": "follow us",
    "footer.titles.contact": "contact us",
    "header.actions.login": "My Account",
    "header.actions.logout": "Ausloggen",
    "header.actions.settings": "Settings",
    "nav.accessibility.title": "Accessibility",
    "nav.api.title": "API",
    "nav.blog_en_de_liability_insurance_germany.title": "Private Liability Insurance Explained",
    "nav.blog_en_de_deductible.title": "Deductible",
    "nav.blog_en_de_insurances_in_germany.title": "Expat Insurance",
    "nav.blog_en_de_laptop_insurance_germany.title": "Laptop Insurance",
    "nav.blog_en_de_camera_insurance.title": "Camera Insurance",
    "nav.blank.title": "",
    "nav.blog.title": "Blog",
    "nav.car.title": "",
    "nav.car_explained.title": "",
    "nav.claims.title": "Claims",
    "nav.community.title": "Community",
    "nav.covid_19.title": "",
    "nav.expats_de.title": "Blog",
    "nav.expats_nl.title": "",
    "nav.faq.title": "FAQ",
    "nav.giveback.title": "Giveback",
    "nav.giveback_2021.title": "Giveback",
    "nav.global_expansion.title": "Where We're Live",
    "nav.home.title": "Home",
    "nav.homeowners.title": "",
    "nav.imprint.title": "Imprint",
    "nav.insurance_card.title": "",
    "nav.insuropedia.title": "Insurance Dictionary",
    "nav.investors.title": "",
    "nav.legal_stuff.title": "Legal Stuff",
    "nav.life.title": "",
    "nav.makers.title": "Join the Team",
    "nav.manage_cookies.title": "",
    "nav.partners_program.title": "Partners Program",
    "nav.personal_liability_hub.title": "",
    "nav.pet.title": "",
    "nav.pet_dog_insurance_explained.title": "",
    "nav.pet_insurance.title": "",
    "nav.policy_two.title": "Policy 2.0",
    "nav.privacy_policy.title": "Privacy Policy",
    "nav.renters.title": "",
    "nav.renters_hub.title": "",
    "nav.reviews.title": "",
    "nav.sitemap.title": "",
    "nav.term_life.title": "",
    "nav.terms_of_service.title": "Terms of Service",
    "nav.transparency.title": "Transparency",
    "header.accessibility.title": "Accessibility",
    "header.api.title": "API",
    "header.blank.title": "",
    "header.blog.title": "Blog",
    "header.car.title": "",
    "header.car_explained.title": "",
    "header.claims.title": "Claims",
    "header.community.title": "Community",
    "header.covid_19.title": "",
    "header.expats_de.title": "Blog for Expats",
    "header.expats_nl.title": "",
    "header.faq.title": "FAQ",
    "header.giveback.title": "Giveback",
    "header.giveback_2021.title": "Giveback",
    "header.global_expansion.title": "Where We're Live",
    "header.home.title": "Home",
    "header.homeowners.title": "",
    "header.imprint.title": "Imprint",
    "header.insurance_card.title": "",
    "header.insuropedia.title": "Insurance Dictionary",
    "header.investors.title": "",
    "header.legal_stuff.title": "Legal Stuff",
    "header.life.title": "",
    "header.makers.title": "Join the Team",
    "header.manage_cookies.title": "",
    "header.partners_program.title": "Partners Program",
    "header.personal_liability_hub.title": "",
    "header.pet.title": "",
    "header.pet_dog_insurance_explained.title": "",
    "header.pet_insurance.title": "",
    "header.policy_two.title": "Policy 2.0",
    "header.privacy_policy.title": "Privacy Policy",
    "header.renters.title": "",
    "header.renters_hub.title": "",
    "header.reviews.title": "",
    "header.sitemap.title": "",
    "header.term_life.title": "",
    "header.terms_of_service.title": "Terms of Service",
    "header.transparency.title": "Transparency",
    "privacy_banner.content": "We use cookies and other technologies to give you the best possible user experience and to customize advertising on and off our website. In addition, our partners may use cookies and other technologies to provide you with marketing information. Read more about this and your right to opt-out in our [Privacy Policy](privacyPolicyLink).",
    "privacy_banner.cta": "accept all",
    "cookie_consent.information.reject_btn_title": "Reject all",
    "cookie_consent.customize.categories.tracking.title": "Targeting/advertising cookies",
    "cookie_consent.customize.categories.tracking.description": "These are marketing cookies that help us to provide the most personalized offers",
    "nav.do_not_share_my_personal_information.title": "Do not share my personal information",
    "cookie_consent.customize.personalInfo.block3.description": "If you have an account with us and want to change, or delete your data, email us at privacy@lemonade.com or call us toll-free at 844-733-8666",
    "cookie_consent.customize.personalInfo.block1.description": "We use information collected through cookies to give you the best experiences we can. But, no worries, you can opt out from them at any time. As a California resident you have rights around the sale of personal information.",
    "cookie_consent.customize.personalInfo.block1.title": "Do not share my personal information"
};

export { enDeTranslation as default };
